<template>
  <v-dialog v-model="dialog" max-width="800" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        height="100%"
        small
        text
        class="terms-btn"
      >
        <span class="d-md-inline font-weight-regular">
          I accept the rental
        </span>
        <span
          class="pl-1 d-md-inline font-weight-regular text-decoration-underline"
        >
          terms&conditions
        </span>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span>Terms & Conditions</span>
        <v-btn class="ml-auto" icon @click="dialog = false">
          <v-icon small>fa fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-10 px-sm-20">
        <div style="white-space: pre-wrap" v-html="text" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { axios } from "@/store/fetch";

export default {
  name: "listing-terms-info",
  props: ["listingId", "range"],
  data: () => ({
    dialog: false,
    text: null,
  }),

  async mounted() {
    const payload = {
      id: this.listingId,
      check_in: this.range[0],
      check_out: this.range[1],
    };

    try {
      this.isLoading = true;
      const res = await axios.get("/terms", {
        params: payload,
      });
      if (res) {
        this.text = res.data.terms;
      }
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.terms-btn {
  text-transform: none;
  padding: 0 !important;
}
</style>
